import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const getActionDashboardCount = createApi(`ActionDashboardSlice`,"GET");

const ActionDashboardSlice = createSlice({
  name: 'ActionDashboardSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getActionDashboardCount.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getActionDashboardCount.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getActionDashboardCount.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default ActionDashboardSlice.reducer;